 <template lang="pug">
  app-modal(
    :closeOutside="false",
    :titulo="getTitulo",
    :modalNova="true",
    :width="500",
    @closeModal="closeModal()"
    )

    template(slot="body")
      .container
        validation-observer(ref="observer")
          validation-provider(rules="required|min_painel:2", v-slot="{ errors }")
            app-label(label="Nome do painel: ",:required="true")
            el-input.input.width-50(
              v-model="painel.nome"
              :maxlength="50"
              :class="{'erro' : errors.length}"
            )
            br
            span.help.erro {{ errors[0] }}
            br
          app-label(label="Descrição:", :required="false")
          el-input.input.width-50(
            v-model="painel.descricao"
            type="textarea"
          )
    template(slot="footer")
      div.buttons
        el-button(
          type="primary",
          key="botao-confirma",
          @click="criarPainel()"
        ) {{getLabel}}
</template>
<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

const PAINEL_EMPTY = {
  id: null,
  nome: null,
  descricao: null
}

export default {

  data () {
    return {
      painel: cloneDeep(PAINEL_EMPTY)
    }
  },

  props: ['titulo', 'idPainel'],

  mixins: [
    AppNotificacao
  ],

  computed: {
    getTitulo () {
      return this.idPainel ? 'Editar painel' : 'Criar painel'
    },

    getLabel () {
      return this.idPainel ? 'Atualizar' : 'Criar'
    }
  },

  methods: {
    ...mapActions({
      salvarPainel: 'paineis/save',
      findById: 'paineis/findById'
    }),
    closeModal () {
      this.$emit('closeModal')
    },

    async getPainel () {
      await this.findById(this.idPainel).then((response) => {
        this.painel = response
      })
    },

    async criarPainel () {
      const valido = await this.$refs.observer.validate()

      if (valido) {
        await this.salvarPainel(this.painel).then(() => {
          if (this.idPainel) {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.SUCESSO_EDITAR_PAINEL
            )
          } else {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.SUCESSO_CADASTRAR_PAINEL
            )
          }

          this.closeModal()
          this.$emit('refreshList')
        })
      }
    }
  },
  created () {
    if (this.idPainel) {
      this.getPainel()
    }
  },
  components: {
    AppModal,
    AppLabel
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.container {
  text-align: left;
  justify-content: center;
  padding: 10px;
}

.width-50 {
  width: 100%;
}

.form-assinatura {
  margin-top: 50px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/ModalCadastroPainel.vue